enum URL_SET_SOURCES {
	UPLOAD = 'UPLOAD', // list
	URL_DISCOVERY = 'URL_DISCOVERY' // crawl
}

export { URL_SET_SOURCES };
